import { Avatar, Box, Chip, Drawer, IconButton, Stack, TableCell, TableRow, Tooltip } from "@mui/material";
import PopOverForm from "components/PopOverForm";
import { MdEditDocument } from "react-icons/md";
import dayjs from "dayjs";
import { useState } from "react";
import { FcInspection, FcFeedback, FcRules } from "react-icons/fc";
import { VideoCameraFrontTwoTone, PeopleAltTwoTone, Task, OpenInNewTwoTone } from '@mui/icons-material';
import { useDispatch } from "react-redux";
import { getReport, save as saveEvaluation } from "store/evaluation/admin-evaluation"
import { useNavigate } from "react-router-dom";
import { useBasePath } from "components/Providers";
import * as snackbar from '../../../../utils/snackbar'
import { generateEvaluationPdf } from "../utils/generatePdfReport";

export default function AdminListItem({ item, selectedAcademicYear }) {
  const dispatch = useDispatch() 
  const navigate = useNavigate()
  const basePath = useBasePath()
  const [openPickerFor, setOpenPickerFor] = useState(null); 
  

  const handleDateSelected = async (date, evaluationDateType, meetingType, meetingTypeKey) => {
    if (date && !item?.evaluation?.id) {
        const adminEvaluation = {
            personId: item.id,
            [evaluationDateType]: date,
            academicYearId: selectedAcademicYear.id,
            [meetingTypeKey]: meetingType
        }
        await dispatch(saveEvaluation(adminEvaluation));
    }
    if (date && item?.evaluation?.id) {
        const adminEvaluation = {
            [evaluationDateType]: date,
            id: item?.evaluation?.id,
            [meetingTypeKey]: meetingType

        }
        await dispatch(saveEvaluation(adminEvaluation));
    }
  }

  const renderDateCell = (key, label, typeKey, ppKey) => {
    const date = item?.evaluation?.[key];
    const meetingType = item?.evaluation?.[typeKey];
    const powerPointLink = item?.evaluation?.[ppKey]

    const isPickerOpen = openPickerFor === key;

    return (
      <TableCell>
        {date ? (
          <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
            <Chip
              label={dayjs(date).format('MM/DD/YYYY h:mm A')}
              deleteIcon={<MdEditDocument style={{ fontSize: 18 }} />}
              onDelete={() => setOpenPickerFor(key)}
            />
            {meetingType && (
            <Tooltip title={meetingType === 'in-person' ? 'In Person Meeting' : 'Virtual Meeting'} arrow>
              <Box sx={{display: 'inline-flex', alignItems: 'center', justifyContent: 'center', cursor: 'default', pointerEvents: 'auto'}}>
                {meetingType === 'in-person' ? <PeopleAltTwoTone color="secondary" /> : <VideoCameraFrontTwoTone color='secondary' />}
              </Box>
            </Tooltip>
            )}
            {powerPointLink && (
            <Tooltip title={'Open PowerPoint File'} arrow>
                        <Box
                            sx={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', pointerEvents: 'auto' }}
                            onClick={() => window.open(powerPointLink, '_blank')}
                        >
                            <OpenInNewTwoTone color='secondary' />
                        </Box>
            </Tooltip>
            )}
            {isPickerOpen && (
              <PopOverForm
                hideButton
                openExternally
                defaultDate={date}
                onSubmit={(newDate, newType) => handleDateSelected(newDate, key, newType, typeKey)}
                onCloseExternal={() => setOpenPickerFor(null)}
                selectOptions={[
                  { value: 'in-person', label: 'In Person' },
                  { value: 'virtual', label: 'Virtual' },
                ]}
                selectLabel="Meeting Type"
                selectValue={meetingType}
              />
            )}
          </Box>
        ) : (
          <PopOverForm
            buttonText={label}
            onSubmit={(newDate, newType) => handleDateSelected(newDate, key, newType, typeKey)}
            selectOptions={[
              { value: 'in-person', label: 'In Person' },
              { value: 'virtual', label: 'Virtual' },
            ]}
            selectLabel="Meeting Type"
          />
        )}
      </TableCell>
    );
  };


  return (
    <>    
      <TableRow hover>
          <TableCell>
              <Stack direction='row' spacing={2} alignItems='center'>
                  <Avatar src={item?.profilePicture?.location} alt={item?.firstName} />
                  <Box>{item?.lastName}, {item?.firstName}</Box>
                  { item?.evaluation?.isFinalized && 
                      <Tooltip title="Evaluation Finalized" arrow>
                        <Task color="success" />
                      </Tooltip>
                  }
              </Stack>
          </TableCell>
          {renderDateCell('visit1Date', 'Schedule Visit', 'visit1Type', 'visit1Link')}
          {renderDateCell('visit2Date', 'Schedule Visit', 'visit2Type', 'visit2Link')}
          {renderDateCell('summativeDate', 'Schedule Visit', 'summativeType', 'summativeLink')}
          <TableCell>
              <Stack spacing={0} direction='row'>
                  <Tooltip title="Evaluate" arrow>
                      <IconButton 
                        size="medium" 
                        onClick={() => {
                          if (!item?.evaluation) {
                              snackbar.error('At least one visit must be scheduled before evaluating administrator.');
                          } else {
                            navigate(`/admin-evaluation/evaluation/admin/add`, { state: { item } });
                          }
                        }} 
                      >
                          <FcInspection />
                      </IconButton>
                  </Tooltip>
                  <Tooltip title="Feedback" arrow >
                      <IconButton 
                        size="medium" 
                        onClick={() => {
                          if (!item?.evaluation?.id) {
                            snackbar.error('At least one visit must be scheduled to submit feedback.');
                          } else {
                            navigate(`${basePath}/feedback/${item?.evaluation?.id}`);
                          }
                        }} 
                      >
                          <FcFeedback />
                      </IconButton>
                  </Tooltip>
                  <Tooltip title="Generate Report" arrow>
                      <IconButton 
                        size="medium" 
                        onClick={async () => {
                          if (!item?.evaluation?.id) {
                            snackbar.error('At least one visit must be scheduled before generating report.');
                          } else {
                            try {
                              const reportPayload = await dispatch(getReport({ id: item?.evaluation?.id }));
                              const evaluationReport = reportPayload?.payload;
                              const person = { firstName: item?.firstName, lastName: item?.lastName };
                              if (evaluationReport) {
                                generateEvaluationPdf(evaluationReport, person, selectedAcademicYear);
                                snackbar.success('Report generated successfully.');
                              } else {
                                snackbar.error('Failed to generate report.');
                              }
                            } catch (error) {
                              snackbar.error('An error occurred while generating the report.');
                            }
                          }
                        }} 
                      >
                          <FcRules />
                      </IconButton>
                  </Tooltip>
              </Stack>
          </TableCell>
      </TableRow>
      <Drawer>

      </Drawer>
    </>
  )
}
